<span class="form-group" style="display: inline-block; max-width: 200px; height: 25px; margin-left: 5px; padding-left: 0px; margin-right: 10px; padding-top: 0px; ">

  @if (mapService.mapRef) {
    <merkator-locatie-service
      [mapComp]="mapService.mapRef" [proxyConfig]="proxyConfig" [appearance]="'standard'">
    </merkator-locatie-service>
  }
</span>